var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"min-vh-100 h-100 d-flex"},[_c('Sidebar'),_c('div',{staticClass:"d-flex flex-column w-100",attrs:{"id":"content-wrapper"}},[_c('div',{staticClass:"flex-grow-1",attrs:{"id":"content"}},[_c('Topbar'),_c('div',{staticClass:"container-fluid px-4"},[_c('RouterView')],1)],1),_c('footer')])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }